import './background.css'

const FirstBackground = () => {
    return (
        <div className='FirstBackground'/>
    );
}

export default FirstBackground